var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSirenTurnedOff = function SvgSirenTurnedOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3063",
    fill: "currentColor",
    fillOpacity: 0.7,
    transform: "matrix(.5 0 0 .5 -257.9 990.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4184",
    d: "M566.91 213.47a1.96 1.96 0 0 0-1.062.5l-15.656 14.625h-11.125c-1.014.005-1.933.924-1.938 1.938v19.469c.004 1.013.924 1.932 1.938 1.937h1.093l28.97-28.969v-7.562c.005-1.114-1.117-2.094-2.22-1.938zm2.219 25.062-16.094 16.094 12.812 11.938c.552.52 1.43.68 2.125.375s1.164-1.054 1.156-1.812v-26.594z",
    color: "currentColor",
    style: {
      blockProgression: "tb",
      textIndent: 0,
      textTransform: "none"
    },
    transform: "translate(0 -160)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect4203",
    d: "M306.22 449.95h66v5h-66z",
    transform: "rotate(-45)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSirenTurnedOff);
export default ForwardRef;